const review={
    SEE_ALL_REVIEW:"مشاهده نظرات ثبت شده",
    RATE_COUNT:"{score} امتیاز ثبت شده",
    REVIEW_PAGE_TITLE:"نظرات {title}",
    REVIEW_SUBMIT_ONLY_IN_ANDROID:"فعلا فقط در نسخه اندروید امکان ثبت نظر وجود دارد",

}

export default review